module.exports = __webpack_public_path__ + "img/img18.423831ed.jpg";